import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldAlert, Mail } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

interface BannedScreenProps {
  reason?: string | null;
}

export function BannedScreen({ reason }: BannedScreenProps) {
  const { signOut } = useAuth();
  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-6 bg-background">
      <Card className="w-full max-w-md">
        <CardContent className="p-6 space-y-4 text-center">
          <div className="w-14 h-14 rounded-full bg-destructive/10 mx-auto flex items-center justify-center">
            <ShieldAlert className="w-7 h-7 text-destructive" />
          </div>
          <div className="space-y-1">
            <h1 className="text-xl font-semibold">Account suspended</h1>
            <p className="text-sm text-muted-foreground">
              Your access to SpotrAI has been restricted for violating our
              community guidelines.
            </p>
          </div>
          {reason && (
            <p className="text-xs text-muted-foreground bg-secondary/50 rounded-lg px-3 py-2">
              Reason: {reason}
            </p>
          )}
          <div className="pt-2 space-y-2">
            <a
              href="mailto:spotraihelp@gmail.com?subject=Account%20Appeal&body=Hi%20SpotrAI%20team%2C%0A%0AI%20would%20like%20to%20appeal%20my%20account%20suspension.%0A%0A"
              className="block"
            >
              <Button className="w-full" size="lg">
                <Mail className="w-4 h-4 mr-2" /> Contact Support
              </Button>
            </a>
            <Button
              variant="outline"
              className="w-full"
              onClick={() => signOut()}
            >
              Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
